/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  SitemapControllerGetSitemapPartQueryResponse,
  SitemapControllerGetSitemapPartPathParams,
  SitemapControllerGetSitemapPartHeaderParams,
  SitemapControllerGetSitemapPart404,
  SitemapControllerGetSitemapPart503,
} from '../types/SitemapControllerGetSitemapPart.ts';

function getSitemapGetSitemapPartUrl(key: SitemapControllerGetSitemapPartPathParams['key']) {
  const res = { method: 'GET', url: `/api/sitemap/parts/${key}` as const };
  return res;
}

/**
 * @summary Stream a published XML sitemap part for the current website.
 * {@link /api/sitemap/parts/:key}
 */
export async function sitemapGetSitemapPart(
  key: SitemapControllerGetSitemapPartPathParams['key'],
  headers?: SitemapControllerGetSitemapPartHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    SitemapControllerGetSitemapPartQueryResponse,
    ResponseErrorConfig<SitemapControllerGetSitemapPart404 | SitemapControllerGetSitemapPart503>,
    unknown
  >({
    method: 'GET',
    url: getSitemapGetSitemapPartUrl(key).url.toString(),
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  });
  return res.data;
}
